// Behavior-level. Developer Catalog is BETA (Android accuracy caveat surfaced).

export default {
  title: 'Bundle Lookup',
  summary:
    "Look up app details from bundle IDs, or browse a developer's entire app portfolio straight from their store page.",

  sections: [
    {
      h: 'What this tool does',
      p: [
        'Resolves a list of iOS / Android bundle IDs to app details — name, developer, store info — in one pass.',
        'In Developer Catalog mode, it takes a developer and pulls the full list of apps in their store portfolio.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        'You have raw bundle IDs and need human-readable app and developer names.',
        'You want to see everything a given developer publishes — useful for vetting a portfolio or mapping inventory.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Lookup mode:** paste bundle IDs (iOS numeric or Android reverse-domain) and run — you get per-app details and a found / total summary.',
        '**Developer Catalog mode:** enter the developer and pull their portfolio of apps.',
      ],
    },
    {
      callout:
        'Developer Catalog is marked **BETA** — Android portfolio results in particular can be incomplete or imperfectly matched. Treat the catalog as a strong lead, not a definitive list.',
    },
  ],

  faqs: [
    {
      q: "An app didn't resolve.",
      a: "The listing may be region-restricted, removed, or the ID mistyped. A non-resolving ID isn't necessarily a dead app.",
    },
    {
      q: 'iOS vs Android IDs?',
      a: 'iOS apps use numeric App Store IDs; Android uses reverse-domain bundle IDs (com.example.app). The tool detects which you\u2019ve pasted.',
    },
  ],
};
